import { call, put, delay } from "redux-saga/effects";
import { balanceApi } from "@services/api";
import { getAllStatementsActions } from "../slices";

function* getAllStatementsWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getAllStatementsActions.pending());
    const response = yield call(balanceApi.getAllStatements, payload);
    yield put(getAllStatementsActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllStatementsActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllStatementsWorker };
